import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    DialogProps,
    Box,
} from "@mui/material";
import HoverButton from "../Buttons/HoverButton";

interface ConfirmDialogProps extends DialogProps {
    open: boolean;
    title?: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    onConfirm: () => void;
    onCancel: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
    open,
    title = "Confirm",
    message,
    confirmText = "Confirm",
    cancelText = "Cancel",
    onConfirm,
    onCancel,
    ...props
}) => {
    return (
        <Dialog
            open={open}
            onClose={onCancel}
            PaperProps={{
                sx: {
                    borderRadius: "6px",
                    padding: "8px 6px",
                    minWidth: "420px",
                    boxShadow:
                        "0px 4px 18px rgba(0,0,0,0.07), 0px 1px 3px rgba(0,0,0,0.1)",
                },
            }}
            {...props}
        >
            <DialogTitle
                sx={{
                    fontSize: "1.1rem",
                    fontWeight: 600,
                    pb: 1,
                }}
            >
                {title}
            </DialogTitle>

            <DialogContent sx={{ pb: 2 }}>
                <Typography
                    sx={{
                        fontSize: "0.95rem",
                        lineHeight: 1.5,
                    }}
                >
                    {message}
                </Typography>
            </DialogContent>

            <DialogActions
                sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 1.5,
                    px: 2,
                    pb: 1.5,
                }}
            >
                <HoverButton
                    onClick={onCancel}
                    text={cancelText}
                    color="#2bb9bb"
                    hoverColor="white"
                    backgroundColor="secondary"
                    hoverBackgroundColor="primary.main"
                    transitionTime="0.2s"
                    sx={{ border: '2px solid #2bb9bb', fontWeight: 'bold' }}
                />

                <HoverButton
                    onClick={onConfirm}
                    text={confirmText}
                    color = 'red'
                    hoverColor="secondary.contrastText"
                    backgroundColor="white"
                    hoverBackgroundColor="red"
                    transitionTime="0.2s"
                    sx={{ border: '2px solid red', fontWeight: 'bold' }}
                />
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;
